import styled from "@emotion/styled";
export const StyledBaseFooterComponent = styled.div``;
